import { createSlice } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";

import { deserialize } from "utils/storeUtils";
import PageRepository from "repositories/PageRepository";
import { jjLogger } from "utils/logUtils";

const initialState = {
  homePage: null,
  carousel: null,
  featuredEcards: null,
  viewMoreButton: null,
};

const homePageSlice = createSlice({
  name: "homePage",
  initialState,
  reducers: {
    loadHomePageSuccess(state, { payload }) {
      state.homePage = deserialize(payload);
    },
    loadCarousel(state, { payload }) {
      state.carousel = deserialize(payload);
    },
    loadFeaturedEcards(state, { payload }) {
      state.featuredEcards = deserialize(payload);
    },
    loadViewMoreButton(state, { payload }) {
      state.viewMoreButton = deserialize(payload);
    },
  },
});

export const { actions } = homePageSlice;
export default homePageSlice.reducer;

export const useHomePageActions = () => {
  const dispatch = useDispatch();

  const loadHomePage = () => {
    return PageRepository.show("home-page")
      .then(({ data }) => {
        const response = data;
        const modules = [...response.data?.attributes?.pageModules];
        delete response.data?.attributes?.pageModules;
        dispatch(homePageSlice.actions.loadHomePageSuccess(data));
        dispatch(homePageSlice.actions.loadCarousel({ data: modules[0] }));
        dispatch(homePageSlice.actions.loadFeaturedEcards({ data: modules[1] }));
        dispatch(homePageSlice.actions.loadViewMoreButton({ data: modules[2] }));
        return data;
      })
      .catch((error) => jjLogger.logError(error));
  };

  return {
    loadHomePage,
  };
};
